// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Pervasives from "../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";

function fromString(raisedBy) {
  if (raisedBy === undefined) {
    return ;
  }
  switch (raisedBy) {
    case "Customer" :
        return /* Customer */0;
    case "Partner" :
        return /* Partner */1;
    default:
      return ;
  }
}

function toString(raisedBy) {
  if (raisedBy) {
    return "Partner";
  } else {
    return "Customer";
  }
}

function getListOfRaisedBy(param) {
  return {
          hd: /* Customer */0,
          tl: {
            hd: /* Partner */1,
            tl: /* [] */0
          }
        };
}

function nonOptionalFromString(raisedBy) {
  switch (raisedBy) {
    case "Customer" :
        return /* Customer */0;
    case "Partner" :
        return /* Partner */1;
    default:
      return Pervasives.failwith("Invalid Caller type" + raisedBy);
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), nonOptionalFromString);
}

function t_encode(raised_by) {
  return Decco.stringToJson(raised_by ? "Partner" : "Customer");
}

export {
  fromString ,
  toString ,
  getListOfRaisedBy ,
  nonOptionalFromString ,
  t_decode ,
  t_encode ,
  
}
/* No side effect */
